<template>
  <div id="distributorList">
    <div v-if="searchHappened">
      <div v-if="distributors.length">
        <div class="distributor-list-wrapper">
          <DistributorCard
            v-for="(distributor) in distributors"
            :key="distributor.id"
            :distributor="distributor"
          />
        </div>
      </div>
      <div v-else class="no-models">No Distributors Found</div>
    </div>
  </div>
</template>

<script>
import DistributorCard from '@/components/DistributorCard.vue'

export default {
  name: 'DistributorSearchResults',
  components: {
    DistributorCard
  },
  props: {
    searchHappened: Boolean,
    distributors: Array
  }
}
</script>
